const Faq = {
  init() {
    this.details = document.querySelectorAll('details');
    this.resizeTimer = null;

    // 初回実行
    this.handleDetailsState();
    
    // SP時のみアニメーション設定
    this.setupAnimation();

    // リサイズイベント登録
    window.addEventListener('resize', () => this.resize());
  },

  handleDetailsState() {
    const isMobile = window.innerWidth <= 768;
    
    this.details.forEach((detail, index) => {
      if (isMobile) {
        if (index === 0) {
          detail.setAttribute('open', '');
        } else {
          detail.removeAttribute('open');
        }
      } else {
        detail.setAttribute('open', '');
      }
    });
  },

  setupAnimation() {
    this.details.forEach((detail) => {
      const summary = detail.querySelector('summary');
      const content = detail.querySelector('summary + *');
      
      if (!content) return;

      // ラッパー要素を作成してアニメーション用に使用
      const wrapper = document.createElement('div');
      wrapper.style.overflow = 'hidden';
      wrapper.style.transition = 'height 0.3s ease';
      
      // コンテンツをラッパーで囲む
      content.parentNode.insertBefore(wrapper, content);
      wrapper.appendChild(content);

      summary.addEventListener('click', (e) => {
        const isMobile = window.innerWidth <= 768;
        
        // SP時のみアニメーション適用
        if (!isMobile) return;

        e.preventDefault();

        const isOpen = detail.hasAttribute('open');

        if (isOpen) {
          // 閉じるアニメーション
          const startHeight = wrapper.scrollHeight;
          wrapper.style.height = startHeight + 'px';
          
          // 強制的にリフロー
          wrapper.offsetHeight;
          
          wrapper.style.height = '0px';

          setTimeout(() => {
            detail.removeAttribute('open');
            wrapper.style.height = '';
          }, 300);
        } else {
          // 開くアニメーション
          detail.setAttribute('open', '');
          
          const endHeight = wrapper.scrollHeight;
          wrapper.style.height = '0px';
          
          // 強制的にリフロー
          wrapper.offsetHeight;
          
          wrapper.style.height = endHeight + 'px';

          setTimeout(() => {
            wrapper.style.height = '';
          }, 300);
        }
      });
    });
  },

  resize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.handleDetailsState();
    }, 100);
  }
};

export default Faq;